"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _createSvgIcon = _interopRequireDefault(require("../utils/createSvgIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = (0, _createSvgIcon["default"])( /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
  d: "M24.81 10.51L22.5 9.27 24.82 5a.64.64 0 0 0 .05-.49.66.66 0 0 0-.32-.39l-4.82-2.6a.65.65 0 0 0-.88.26l-2.62 4.84-9.09 16.84v.09a.8.8 0 0 0 0 .15l-.21 6.17a.64.64 0 0 0 .34.59.68.68 0 0 0 .31.08.63.63 0 0 0 .37-.12l5-3.56a.47.47 0 0 0 .1-.1l.07-.09 8.77-16.27 1.74.94-4.74 8.79 1.14.62 5.05-9.37a.65.65 0 0 0-.27-.87zm-5.12-7.57l3.67 2-2 3.72-3.68-2zM8.32 24.84l3 1.61-3.11 2.2zm3.95.65l-3.68-2 8.47-15.7 3.68 2z"
})));
module.exports = exports.default;